import { InjectionToken } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PredefinedDateRange } from '../../common.types';

export type DateRangeConfig = Record<PredefinedDateRange, () => [Moment, Moment]>;
export const dateRangeConfig: DateRangeConfig = {
  [PredefinedDateRange.TODAY]: () => [
    moment.utc().startOf('day'),
    moment.utc().endOf('day'),
  ],

  [PredefinedDateRange.YESTERDAY]: () => [
    moment.utc().subtract(1, 'day').startOf('day'),
    moment.utc().subtract(1, 'day').endOf('day'),
  ],

  [PredefinedDateRange.LAST_7_DAYS]: () => [
    moment.utc().subtract(7, 'day').startOf('day'),
    moment.utc().endOf('day'),
  ],

  [PredefinedDateRange.LAST_14_DAYS]: () => [
    moment.utc().subtract(14, 'day').startOf('day'),
    moment.utc().endOf('day'),
  ],

  [PredefinedDateRange.LAST_30_DAYS]: () => [
    moment.utc().subtract(30, 'day').startOf('day'),
    moment.utc().endOf('day'),
  ],

  [PredefinedDateRange.LAST_MONTH]: () => [
    moment.utc().subtract(1, 'months').startOf('month'),
    moment.utc().subtract(1, 'months').endOf('month'),
  ],

  [PredefinedDateRange.THIS_MONTH]: () => [
    moment.utc().startOf('month'),
    moment.utc().endOf('day'),
  ],

  [PredefinedDateRange.THIS_YEAR]: () => [
    moment.utc().startOf('year'),
    moment.utc().endOf('day'),
  ],

  [PredefinedDateRange.LAST_YEAR]: () => [
    moment.utc().subtract(1, 'year').startOf('day'),
    moment.utc().endOf('day'),
  ],
};

export const DATE_RANGE_CONFIG = new InjectionToken<DateRangeConfig>('DATE_RANGE_CONFIG');
